import React from 'react';
import './VideoLoop.scss';
import videoLoopD from '../../assets/videoLoopD.mp4';

function VideoLoop() {
  return (
    <section className="videoLoop">
      <div className="videoLoop__videoContainer">
        <video autoPlay muted loop playsInline className="video">
          <source src={videoLoopD} type="video/mp4" />
          Your browser does not support HTML5 video.
        </video>
      </div>
      <div className="videoLoop__copyContainer">
        <p className="videoLoop__copyContainer-copy">
          Use our{' '}
          <a
            className="hyperLink mapLink"
            href="https://sponsorcontent.cnn.com/interactive/nar/map/"
            target="_blank"
            rel="noreferrer"
          >
            interactive map on <span className="italic">The State of Housing in America</span>
          </a>{' '}
          to discover which metro areas are most affordable and find out where prices are rising
          fastest across the country.
        </p>
        <a
          className="videoLoop-control mapLink"
          target="_blank"
          rel="noreferrer"
          href="https://sponsorcontent.cnn.com/interactive/nar/map/"
        >
          <button className="button-explore">Explore Map</button>
        </a>
      </div>
    </section>
  );
}

export default VideoLoop;
